module.exports = function (_ref) {
  var _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? null : _ref$error,
    _ref$utxokey = _ref.utxokey,
    utxokey = _ref$utxokey === void 0 ? '' : _ref$utxokey,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? '' : _ref$status,
    _ref$slip = _ref.slip,
    slip = _ref$slip === void 0 ? null : _ref$slip;
  var statusHtml = '';
  if (loading) {
    statusHtml = "<p class=\"explorer-address-status\">Checking UTXO set\u2026</p>";
  } else if (error) {
    statusHtml = "\n      <div class=\"explorer-teaser-loading explorer-teaser-error\">\n        <p class=\"explorer-teaser-loading-title\">Unable to look up UTXO</p>\n        <p class=\"explorer-teaser-loading-message\">".concat(error, "</p>\n      </div>\n    ");
  }
  var statusSlug = status ? status.toLowerCase().replace(/\s+/g, '-') : '';
  var statusPanel = status && !loading ? "\n      <div class=\"explorer-utxo-status-panel explorer-utxo-status-".concat(statusSlug, "\" role=\"status\">\n        <p class=\"explorer-utxo-status-value\">").concat(status, "</p>\n      </div>\n    ") : '';
  var visitBlockHtml = slip !== null && slip !== void 0 && slip.blockHref && slip !== null && slip !== void 0 && slip.blockInput ? "\n      <p class=\"explorer-utxo-block-visit\">\n        <a href=\"".concat(slip.blockHref, "\" class=\"explorer-link explorer-utxo-block-link\" data-block-input=\"").concat(slip.blockInput, "\">visit the block containing this transaction output...</a>\n      </p>\n    ") : '';
  var fields = [];
  if (slip) {
    fields.push({
      label: 'type',
      value: slip.type || '—'
    });
    fields.push({
      label: 'block id',
      value: slip.blockId || '—'
    });
    fields.push({
      label: 'transaction id',
      value: slip.transactionId || '—'
    });
    fields.push({
      label: 'slip',
      value: slip.slipIndex || '—'
    });
    fields.push({
      label: 'public key',
      value: slip.publicKey || slip.publicKeyHex || '—',
      valueClass: 'explorer-utxo-public-key explorer-tx-meta-value-mono'
    });
    fields.push({
      label: 'amount',
      value: slip.amountDisplay || slip.amount || '—'
    });
  }
  var fieldsHtml = fields.length ? "\n      <dl class=\"explorer-tx-meta explorer-utxo-fields\">\n        ".concat(fields.map(function (field) {
    return "\n          <dt class=\"explorer-tx-meta-label\">".concat(field.label, ":</dt>\n          <dd class=\"explorer-tx-meta-value ").concat(field.valueClass || '', "\">").concat(field.value, "</dd>\n        ");
  }).join(''), "\n      </dl>\n    ") : '';
  return "\n    <main class=\"explorer-content explorer-view-panel explorer-address-page explorer-utxo-page\">\n      <div class=\"explorer-container explorer-stack\">\n        <div class=\"explorer-address-header\">\n          <button type=\"button\" class=\"explorer-back-link\" data-nav=\"home\" aria-label=\"Back to explorer home\">\n            <i class=\"fa-solid fa-arrow-left\"></i>\n          </button>\n          <div class=\"explorer-address-header-text\">\n            <h1 class=\"explorer-page-title\">UTXOKEY</h1>\n            ".concat(utxokey ? "<p class=\"explorer-address-key-raw explorer-mono\">".concat(utxokey, "</p>") : '', "\n          </div>\n        </div>\n\n        <div class=\"explorer-address-dashboard explorer-card explorer-card-padded\">\n          ").concat(visitBlockHtml, "\n          ").concat(statusHtml, "\n          ").concat(statusPanel, "\n          ").concat(fieldsHtml, "\n        </div>\n      </div>\n    </main>\n  ");
};